

/**
 * VideoPlayer
 */
class VideoPlayer {
    constructor(element) {
        console.log('VideoPlayer constructor [element]', element);

        element.videoPlayer = this;

        this.video = element.querySelector('video');
        this.progressBar = element.querySelector('[data-video-bar]');
        this.progress = element.querySelector('[data-video-progress]');
        this.play = element.querySelector('[data-video-play]');
        this.playpause = element.querySelector('[data-video-playpause]');
        this.currenttime = element.querySelector('[data-video-currenttime]');
        this.duration = element.querySelector('[data-video-duration]');

        this.callbacks = {};

        this.video.addEventListener('timeupdate', this.timeupdate.bind(this));

        this.video.addEventListener('click', this.togglePlay.bind(this));
        this.play && this.play.addEventListener('click', this.togglePlay.bind(this));
        this.playpause && this.playpause.addEventListener('click', this.togglePlay.bind(this));
        this.progressBar && this.progressBar.addEventListener('click', this.seek.bind(this));
        
        this.video.addEventListener('loadedmetadata', this);
        this.video.addEventListener('play', this);
        this.video.addEventListener('pause', this);
        this.video.addEventListener('ended', this);
    }

    handleEvent(event) {
        console.log('VideoPlayer.handleEvent(event) [event]', event);

        switch (event.type) {
            case 'loadedmetadata':
                this.currenttime && (this.currenttime.innerHTML = this.toTime(0));
                this.duration && (this.duration.innerHTML = this.toTime(this.video.duration));
                break;

            case 'play':
                this.playpause && (this.playpause.className = 'pause');
                break;

            case 'pause':
                this.playpause && (this.playpause.className = 'play');
                break;

            case 'ended':
                this.playpause && (this.playpause.className = 'replay');
                break;
        }

        this.trigger(event.type, event);
    }

    togglePlay() {
        console.log('VideoPlayer.togglePlay() [this.video.paused]', this.video.paused);
        this.play && (this.play.style.display = 'none');

        this.video.paused ? this.video.play() : this.video.pause();
    }

    timeupdate() {
        console.log('VideoPlayer.timeupdate() [this.video.currentTime]', this.video.currentTime);

        let position = 100 - (this.video.currentTime / this.video.duration * 100);
        this.progress.style.width = position + '%';
        this.currenttime.innerHTML = this.toTime(this.video.currentTime);

        this.trigger('timeupdate');
    }

    seek(event) {
        let context = this.progressBar.getBoundingClientRect(),
            time = (event.pageX - context.left) / context.width * this.video.duration;

        console.log('VideoPlayer.seek(event) [event, time]', event, time);
        
        this.video.currentTime = time;
        this.video.play();
    }

    addEvent(event, callback) {
        console.log('VideoPlayer.addEvent(event, callback) [event]', event);

        if (!this.callbacks[event]) {
            this.callbacks[event] = [];
        }

        this.callbacks[event].push(callback);
    }

    trigger(type, event) {
        console.log('VideoPlayer.trigger(type, event) [event]', event);

        if (!this.callbacks[type]) {
            return;
        }

        this.callbacks[type].forEach(callback => {
            callback(event, this);
        });
    }

    toTime(float) {
        let min = String(parseInt(float / 60)).padStart(2, '0'),
            sec = String(parseInt(float % 60)).padStart(2, '0');
        
        return min + ':' + sec;
    }
}


export default VideoPlayer;

